import React, { Fragment, useEffect, useState } from "react";
import makeStyles from "@mui/styles/makeStyles";
import { map } from "ramda";

import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import Typography from "@mui/material/Typography";

import MediaDialog from "../common/MediaDialog";
import { isBlank, notBlank } from "../../util/ext";
import PanelLoadingIndicator from "../../components/PanelLoadingIndicator";
import { AdapterLuxon } from "@mui/x-date-pickers/AdapterLuxon";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { getSubmissionReportUrl } from "../cspServices";

const useStyles = makeStyles(theme => ({
  actions: {
    padding: theme.spacing(5),
  },

  badge: {
    background: "rgba(125, 218, 252, 0.5)",
    borderRadius: 4,
    padding: "8px 12px",
    gap: 10,
    width: "auto",
    height: 32,
  },

  button: {
    width: "auto",
    textTransform: "capitalize",
  },

  mediaType: {
    fontWeight: 700,
    fontSize: 14,
    lineHeight: "16px",
    color: theme.palette.primary.main,
  },

  otherReason: {
    lineHeight: "2.5rem",
    maxHeight: 150,
    overflowY: "auto !important",
  },

  rejected: {
    backgroundColor: theme.palette.rejected,
    "&:hover": {
      backgroundColor: "rgba(176, 34, 12, 0.7)",
    },
  },

  title: {
    color: theme.palette.primary.darker,
    fontSize: "2.4rem",
    lineHeight: "3.2rem",
  },
}));

const CspSubmissionReportDialog = props => {
  const { open, handleClose, projects } = props;
  const classes = useStyles();

  const [project, setProject] = useState({});
  useEffect(() => {
    if (notBlank(projects)) {
      setProject(projects[0].projectId);
    }
  }, [projects, setProject]);

  const handleChange = event => {
    const project = event.target.value;
    setProject(project);
  };

  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();

  const handleCloseClick = () => {
    handleClose();
  };

  return (
    <Fragment>
      <MediaDialog
        open={open}
        titleClassName={classes.title}
        title="CSP Submission Report"
        handleClose={handleCloseClick}
        content={
          isBlank(projects) ? (
            <PanelLoadingIndicator />
          ) : (
            <Grid container spacing={4}>
              <LocalizationProvider dateAdapter={AdapterLuxon}>
                <Grid item xs={12}>
                  <Typography>
                    Select a Project and date range for the CSP Submission
                    Report
                  </Typography>
                </Grid>

                <Grid item xs={12}>
                  <FormControl fullWidth>
                    <InputLabel>Select a project</InputLabel>
                    <Select
                      labelId="rejection-reason-label"
                      id="rejection-reason"
                      value={project}
                      onChange={handleChange}
                      MenuProps={{
                        anchorOrigin: {
                          vertical: "bottom",
                          horizontal: "left",
                        },
                        transformOrigin: {
                          vertical: "top",
                          horizontal: "left",
                        },
                      }}
                    >
                      {map(
                        project => (
                          <MenuItem
                            key={`project-${project.projectId}`}
                            value={project.projectId}
                          >
                            {project.projectName}
                          </MenuItem>
                        ),
                        projects,
                      )}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={6}>
                  <DatePicker
                    format="MM/dd/yyyy"
                    label="Start Date"
                    value={startDate}
                    onChange={value => setStartDate(value)}
                    slotProps={{
                      textField: {
                        required: true,
                        fullWidth: true,
                        id: "startDate",
                      },
                      openPickerButton: {
                        "aria-label": "change start date",
                      },
                    }}
                  />
                </Grid>

                <Grid item xs={6}>
                  <DatePicker
                    format="MM/dd/yyyy"
                    label="End Date"
                    value={endDate}
                    onChange={value => setEndDate(value)}
                    slotProps={{
                      textField: {
                        required: true,
                        fullWidth: true,
                        id: "endDate",
                      },
                      openPickerButton: {
                        "aria-label": "change start date",
                      },
                    }}
                  />
                </Grid>
              </LocalizationProvider>
            </Grid>
          )
        }
        actionsClassName={classes.actions}
        actions={
          <Grid container alignItems="center">
            <Button
              variant="contained"
              href={getSubmissionReportUrl(project, startDate, endDate)}
              component="a"
              target="_blank"
              classes={{
                root: classes.button,
              }}
            >
              Submit
            </Button>
            <Button onClick={handleCloseClick}>Cancel</Button>
          </Grid>
        }
      />
    </Fragment>
  );
};

export default CspSubmissionReportDialog;
